// TODO maybe this variables can be moved to environment file
export const testConfigDataProvider = {
  raDataProvider: "https://risk.spi3pl-api.com/api/v1/reports",
  authApiDataProvider: "https://auth.spi3pl-tech.com/api/v1",
};
